import * as React from "react"

import Container from "../container/container"

import * as styles from "./steps.module.scss"
import next from "../../assets/testimonials/slider-arrow-next.svg"
import Markdown from "react-markdown"

const BetterSteps = props => {
  const data = props.data.strapiBotanicalReset
  return (
    <div className={styles.steps}>
      <Container>
        <div>
          <h2>{data.StepsHeading}</h2>
          <Markdown>{data.StepsBody}</Markdown>
          <div className={styles.steps__wrap}>
            <div
              className={`${styles.steps__wrap__row} d-flex align-items-center justify-content-evenly`}
            >
              <div className={styles.steps__step}>
                <strong>{data.Steps[0].Heading}</strong>
                <Markdown>{data.Steps[0].Body}</Markdown>
              </div>
              <img
                src={next}
                alt="Arrow"
                className={styles.steps__step__arrow}
              />
              <div className={styles.steps__step}>
                <strong>{data.Steps[1].Heading}</strong>
                <Markdown>{data.Steps[1].Body}</Markdown>
              </div>
              <img
                src={next}
                alt="Arrow"
                className={styles.steps__step__arrow}
              />
              <div className={styles.steps__step}>
                <strong>{data.Steps[2].Heading}</strong>
                <Markdown>{data.Steps[2].Body}</Markdown>
              </div>
              <img
                src={next}
                alt="Arrow"
                className={styles.steps__step__arrow}
              />
              <div className={styles.steps__step}>
                <strong>{data.Steps[3].Heading}</strong>
                <Markdown>{data.Steps[3].Body}</Markdown>
              </div>
              <img
                src={next}
                alt="Arrow"
                className={styles.steps__step__arrow}
              />
              <div className={styles.steps__step}>
                <strong>{data.Steps[4].Heading}</strong>
                <Markdown>{data.Steps[4].Body}</Markdown>
              </div>
            </div>
          </div>
          <Markdown>{data.StepsSecondBody}</Markdown>
        </div>
      </Container>
    </div>
  )
}

export default BetterSteps
